import React from 'react';

import { connect, useSelector } from 'react-redux'

import pageWithSideMenu from '../../containers/pageWithSideMenu'
import pageContent from '../../containers/pageContent'

import UsersTable from './UsersTable'
import CardHeader from '../../containers/CardHeader'

import { Card } from 'react-bootstrap'
import InvalidPermissions from '../../containers/InvalidPermissions'
import { FaPlus } from "react-icons/fa";

const UsersSection = (props) => {
    const isAdmin = useSelector((state) => state.user.isAdmin)
    const isSysadmin = useSelector((state) => state.user.isSysadmin)
    const title = "Users";
    const subtitle = "Listing of all Users"
    const headerAction = isSysadmin ? {'path': "/users/add", 'icon':FaPlus} : {}

    if(!(isSysadmin || isAdmin)) 
        return <InvalidPermissions />
        
    return (
        <Card>
            <CardHeader title={title} description={subtitle} action={headerAction} />
            <UsersTable showDetailsOnClick={false} />
        </Card>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(UsersSection), "Users"));
